(function () {
  var selector = "[data-pf-type='CountDown']";

  function pad(value) {
    return String(value).padStart(2, "0");
  }

  function getSecondsUntilMidnight() {
    var now = new Date();
    var midnight = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + 1,
      0,
      0,
      0,
      0
    );

    return Math.max(0, Math.floor((midnight - now) / 1000));
  }

  function createCustomTimer(countdown) {
    if (countdown.querySelector(".un-eod-countdown")) return;

    var inner = countdown.querySelector(".pf-countdown__inner");
    if (inner) inner.style.display = "none";

    var custom = document.createElement("div");
    custom.className = "un-eod-countdown";
    custom.innerHTML =
      '<div class="un-eod-countdown__row">' +
        '<div><span class="un-eod-countdown__hours">00</span><label>Hours</label></div>' +
        '<span class="un-eod-countdown__colon">:</span>' +
        '<div><span class="un-eod-countdown__mins">00</span><label>Mins</label></div>' +
        '<span class="un-eod-countdown__colon">:</span>' +
        '<div><span class="un-eod-countdown__secs">00</span><label>Secs</label></div>' +
      '</div>';

    countdown.appendChild(custom);
  }

  function updateCountdown(countdown) {
    createCustomTimer(countdown);

    var totalSeconds = getSecondsUntilMidnight();

    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    var hoursEl = countdown.querySelector(".un-eod-countdown__hours");
    var minsEl = countdown.querySelector(".un-eod-countdown__mins");
    var secsEl = countdown.querySelector(".un-eod-countdown__secs");

    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minsEl) minsEl.textContent = pad(minutes);
    if (secsEl) secsEl.textContent = pad(seconds);
  }

  function updateAllCountdowns() {
    var countdowns = document.querySelectorAll(selector);

    countdowns.forEach(function (countdown) {
      updateCountdown(countdown);
    });
  }

  function startCountdown() {
    updateAllCountdowns();

    setInterval(updateAllCountdowns, 1000);
  }

  var earlyStyle = document.createElement("style");
  earlyStyle.textContent =
    selector + " .pf-countdown__inner { display: none !important; }";
  document.head.appendChild(earlyStyle);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startCountdown);
  } else {
    startCountdown();
  }

  var attempts = 0;
  var finder = setInterval(function () {
    attempts += 1;
    updateAllCountdowns();

    if (document.querySelector(selector) || attempts > 40) {
      clearInterval(finder);
    }
  }, 100);
})();
